import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { CURRENT_LANGUAGE, prefixLanguage } from '@utils/urls'
import useChoices from '@/choices'


export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageSwitch',
  props: {
  labelKey: {
    type: String,
    default: 'label',
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;



// const LANG_FOR_SUPERUSER = ['en', 'tr']

const choices = useChoices()

const languages = computed(() => {
  // const isSuperUser = window.isSuperUser

  // if (!isSuperUser) {
  //   return choices.languages.filter(l => !LANG_FOR_SUPERUSER.includes(l.value))
  // }

  return choices.languages
})

const currentLanguage = computed(() => {
  return languages.value.find(el => el.value === CURRENT_LANGUAGE)
})

const filteredLanguages = computed(() => {
  return languages.value.filter(el => el.value !== CURRENT_LANGUAGE)
})

const getLanguageLink = (language: string) => prefixLanguage(window.location.href, { language })

const __returned__ = { props, choices, languages, currentLanguage, filteredLanguages, getLanguageLink, computed, get CURRENT_LANGUAGE() { return CURRENT_LANGUAGE }, get prefixLanguage() { return prefixLanguage }, get useChoices() { return useChoices } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})